import { useEffect, useState } from "react";
import http from "../../../http";
import { endpointName, PMT_TYPE_ID, ST_TYPE_ID } from "../const";
import Chart from "../../../components/Chart";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import moment from "moment";
import { currencyFormat, groupBy, sum } from "../../../config/functions";
import CheckRole from "../../../components/CheckRole";
import { MANAGER } from "../../../config/roles";
import { useDispatch, useSelector } from "react-redux";
import { setShowLoading } from "store/sysSlice";
import CustomDataGrid from "components/customDataGrid";
import { useBizType } from "hooks/useBizType";
import { BIZ_TYPE } from "config/const";
import {
  Box,
  Divider,
  MenuItem,
  Select,
  Stack,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import CustomCard from "components/CustomCard";

const ServicesCall = () => {
  const theme = useTheme()
  const { bizTypeCheck } = useBizType()
  const { bt } = useBizTypeTranslation();
  const dispatch = useDispatch()
  const biz = useSelector((state) => state?.biz?.data);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [data, setData] = useState([]);
  const [dayWork, setDayWork] = useState([]);
  const [weekWork, setWeekWork] = useState([]);
  const [monthWork, setMonthWork] = useState([]);
  const [lastMonthWork, setLastMonthWork] = useState([]);
  const [comparisonCallWork, setComparisonCallWork] = useState([]);
  const [selectedWorkEmp, setSelectedWorkEmp] = useState('Today');

  useEffect(() => {
    dispatch(setShowLoading(true))
    http.get(`${endpointName}/serviceCall`)
      .then((res) => {
        setData(res?.data?.data)

        dispatch(setShowLoading(false))
      })
      .catch((error) => dispatch(setShowLoading(false)));
  }, []);

  useEffect(() => {
    if (data) {
      setDayWork(checkBystType(moment().startOf("day"), null, true));
      setWeekWork(checkBystType(moment().startOf("week"), moment().endOf("week")));
      setMonthWork(checkBystType(moment().startOf("month"), moment().endOf("month")));
      setLastMonthWork(checkBystType(moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")));
    }
  }, [data]);

  useEffect(() => {
    if (dayWork?.empList?.length > 0)
      setComparisonCallWork(dayWork?.empList)
  }, [dayWork])

  const checkBystType = (start, end, isDayWork) => {
    let list = []

    if (isDayWork)
      list = data.filter((call) => call.stTypeId === ST_TYPE_ID.OPEN &&
        moment(call.workDt).isSameOrBefore(moment(start), 'day')
      );
    else
      list = data.filter((call) =>
        moment(call.workDt || call.created).isBetween(moment(start), moment(end))
      );

    if (list?.length > 0) {
      const openServices = list.filter((service) => service.stTypeId === ST_TYPE_ID.OPEN);
      const closeServices = list.filter((service) => service.stTypeId === ST_TYPE_ID.CLOSE);
      const waitingServices = list.filter((service) => service.stTypeId === ST_TYPE_ID.WAITING);
      const totalPrice = sum(list.filter((service) => service.pmtTypeId === PMT_TYPE_ID.PAY), "price");
      // const totalPrice = sum(list, "price");

      const providersExpenses = sum(list, "providersExpenses");
      const noInvoiceNumber = closeServices.filter((item) => !item.hasInvoiceNum)?.length;
      const qty = openServices?.length + closeServices?.length + waitingServices?.length;

      const groupByEmp = groupBy(list, 'employee.id')
      let empList = []

      Object.keys(groupByEmp)?.forEach(key => {
        const call = groupByEmp[key]

        const openWork = call?.filter((service) => service.stTypeId === ST_TYPE_ID.OPEN);
        const waitingWork = call?.filter((service) => service.stTypeId === ST_TYPE_ID.WAITING);
        const closeWork = call?.filter((service) => service.stTypeId === ST_TYPE_ID.CLOSE);

        let item = { name: '', tel: '', open: 0, close: 0, waiting: 0 }
        item.id = call[0]?.employee?.id;
        item.name = call[0]?.employee?.name;
        item.tel = call[0]?.employee?.tel;

        item.open = {
          total: openWork?.length,
          range: openWork?.filter((service) => !moment(service?.workDt).isBefore(moment(), 'day'))?.length,
          notRange: openWork?.filter((service) => moment(service?.workDt).isBefore(moment(), 'day'))?.length,
        }

        item.waiting = {
          total: waitingWork?.length,
          range: waitingWork?.filter((service) => !moment(service?.workDt).isBefore(moment(service?.workEndDt), 'day'))?.length,
          notRange: waitingWork?.filter((service) => moment(service?.workDt).isBefore(moment(service?.workEndDt), 'day'))?.length,
        }

        item.close = {
          total: closeWork?.length,
          range: closeWork?.filter((service) => !moment(service?.workDt).isBefore(moment(service?.workEndDt), 'day'))?.length,
          notRange: closeWork?.filter((service) => moment(service?.workDt).isBefore(moment(service?.workEndDt), 'day'))?.length,
        }
        if (item?.id)
          empList.push(item)
      })

      const chartData = [
        { id: 1, value: openServices?.length, label: "פתוח" },
        { id: 2, value: closeServices?.length, label: "סגור" },
        { id: 3, value: waitingServices?.length, label: "ממתין" },
      ];

      return {
        chartData,
        totalPrice,
        openServices,
        closeServices,
        waitingServices,
        qty,
        list,
        empList,
        noInvoiceNumber,
        providersExpenses,
      };
    }
    else {
      return [];
    }
  };

  const selectedCallWork = (type) => {
    let list = []
    if (type === "Today")
      list = dayWork.empList ?? []
    else if (type === "weekly")
      list = weekWork.empList ?? []
    else if (type === "Month")
      list = monthWork.empList ?? []
    else if (type === "LastMonth")
      list = lastMonthWork.empList ?? []

    setComparisonCallWork(list)
    setSelectedWorkEmp(type)
  }

  if (data?.length === 0) {
    return (
      <Stack width="100%" height='50vh' justifyContent='center' alignItems='center'>
        <Typography variant="h6">{bt('NO_DATA')}</Typography>
      </Stack>
    )
  };

  return (
    <Stack width={{ xs: "100%", md: "auto" }} spacing={2}>

      {bizTypeCheck(BIZ_TYPE.SERVICE_PROVIDER) && !biz?.isSystem
        ? <CheckRole role={MANAGER}>
          <Stack
            direction="row"
            useFlexGap
            flexWrap="wrap"
            spacing={{ xs: 1, md: 2 }}
          >
            <CustomCard width={{ xs: "48%", md: 210 }} justifyContent='center' alignItems='center'>
              <Stack alignItems="center">
                <Typography fontSize={{ xs: 12, md: 14 }}>{bt("REVENUE")}</Typography>
                <Typography fontSize={{ xs: 20, md: 24 }} fontWeight="bold">
                  {currencyFormat(monthWork?.totalPrice ?? 0)}
                </Typography>
              </Stack>
            </CustomCard>

            <CustomCard width={{ xs: "48%", md: 210 }} justifyContent='center' alignItems='center'>
              <Stack alignItems="center">
                <Typography fontSize={{ xs: 12, md: 14 }}>
                  {bt("EXPENSES")}
                </Typography>
                <Typography fontSize={{ xs: 20, md: 24 }} fontWeight="bold">
                  {currencyFormat(monthWork?.providersExpenses ?? 0)}
                </Typography>
              </Stack>
            </CustomCard>

            <CustomCard width={{ xs: "48%", md: 210 }} justifyContent='center' alignItems='center'>
              <Stack alignItems="center">
                <Typography fontSize={{ xs: 12, md: 14 }}>{bt("PROFIT")}</Typography>
                <Typography fontSize={{ xs: 20, md: 24 }} fontWeight="bold">
                  {currencyFormat((monthWork?.totalPrice ?? 0) - (monthWork?.providersExpenses ?? 0))}
                </Typography>
              </Stack>

            </CustomCard>

            <CustomCard width={{ xs: "48%", md: 210 }} justifyContent='center' alignItems='center'>
              <Stack alignItems="center">
                <Typography fontSize={{ xs: 12, md: 14 }}>{bt("NO_INVOICE_NUMBER")}</Typography>
                <Typography fontSize={{ xs: 20, md: 24 }} fontWeight="bold">{monthWork?.noInvoiceNumber}</Typography>
              </Stack>
            </CustomCard>

          </Stack>
        </CheckRole>
        : null
      }

      <Stack
        direction={{ xs: "column", md: "row" }}
        useFlexGap
        flexWrap="wrap"
        spacing={2}
      >
        {/* day */}
        <CustomCard height="100%" justifyContent='center' alignItems='center'>
          <Typography textAlign="center" variant="h6">קריאות להיום</Typography>

          <Stack
            width="100%"
            height="100%"
            direction="row"
            justifyContent="center"
            alignItems="center"
            paddingX={{ xs: 0, md: 5 }}
          >
            <Chart
              data={dayWork?.chartData}
              size={200}
              outerRadiusSize={90}
              cx={2}
            />
          </Stack>

          <Stack
            width="100%"
            direction="row"
            justifyContent="space-between"
            padding={1}
          >
            {dayWork?.chartData?.map((item, idx) => {
              return <Typography key={idx}>{`${item.label}: ${item.value}`}</Typography>;
            })}
          </Stack>
        </CustomCard>

        {/* week */}
        <CustomCard height="100%" justifyContent='center' alignItems='center'>
          <Typography textAlign="center" variant="h6">קריאות לשבוע</Typography>

          <Stack
            width="100%"
            height="100%"
            direction="row"
            justifyContent="center"
            alignItems="center"
            paddingX={{ xs: 0, md: 5 }}
          >
            <Chart
              data={weekWork?.chartData}
              size={200}
              outerRadiusSize={90}
              cx={2}
            />
          </Stack>

          <Stack
            width="100%"
            direction="row"
            justifyContent="space-between"
            padding={1}
          >
            {weekWork?.chartData?.map((item, idx) => {
              return <Typography key={idx}>{`${item.label}: ${item.value}`}</Typography>;
            })}
          </Stack>
        </CustomCard>

        {/* month */}
        <CustomCard height="100%" justifyContent='center' alignItems='center'>
          <Typography textAlign="center" variant="h6">קריאות לחודש</Typography>

          <Stack
            width="100%"
            height="100%"
            direction="row"
            justifyContent="center"
            alignItems="center"
            paddingX={{ xs: 0, md: 5 }}
          >
            <Chart
              data={monthWork?.chartData}
              size={200}
              outerRadiusSize={90}
              cx={2}
            />
          </Stack>

          <Stack
            width="100%"
            direction="row"
            justifyContent="space-between"
            padding={1}
          >
            {monthWork?.chartData?.map((item, idx) => {
              return <Typography key={idx}>{`${item.label}: ${item.value}`}</Typography>;
            })}
          </Stack>
        </CustomCard>

      </Stack>

      <CheckRole role={MANAGER}>
        <CustomCard >
          <Stack
            direction={isMobile ? 'column' : 'row'}
            alignItems='center'
            spacing={2}
            justifyContent='space-between'
          >
            <Select
              sx={{ width: isMobile ? '100%' : 200 }}
              value={selectedWorkEmp}
              size="small"
              onChange={(m) => selectedCallWork(m.target.value)}
            >
              <MenuItem value={"Today"}>{bt("TODAY")}</MenuItem>
              <MenuItem value={"weekly"}>{bt("THIS_WEEK")}</MenuItem>
              <MenuItem value={"Month"}>{bt("THIS_MONTH")}</MenuItem>
              <MenuItem value={"LastMonth"}>{bt("LAST_MONTH")}</MenuItem>
            </Select>

            {!isMobile ? <Typography variant="h6">{bt('BY_EMPLOYEE')}</Typography> : null}

            <Stack direction='row' justifyContent='center' alignItems='center' spacing={3}>
              <Stack direction="row" spacing={0.5}>
                <Stack borderRadius={1} width={15} height={15} bgcolor='black' />
                <Typography variant="body2">{bt('SUM')}</Typography>
              </Stack>
              <Stack direction="row" spacing={0.5}>
                <Stack borderRadius={1} width={15} height={15} bgcolor='success.main' />
                <Typography variant="body2">{bt('RANGE')}</Typography>
              </Stack>
              <Stack direction="row" spacing={0.5}>
                <Stack borderRadius={1} width={15} height={15} bgcolor='error.text' />
                <Typography variant="body2">{bt('NOT_RANGE')}</Typography>
              </Stack>
            </Stack>
          </Stack>

          <CustomDataGrid
            hideFooter
            maxHeight={250}
            rowHeight={40}
            borderRadius="10px 10px 10px 10px"
            columns={[
              {
                field: "name",
                headerName: bt("NAME"),
                width: 150,
                filterable: false,
              },
              {
                field: "open",
                headerName: bt("OPEN"),
                width: 150,
                filterable: false,
                renderCell: (value) => {
                  const total = value?.row?.open?.total
                  const range = value?.row?.open?.range
                  const notRange = value?.row?.open?.notRange
                  return (
                    <Stack height='100%' alignItems='center' direction='row' spacing={0.5}>
                      <Typography>{total}</Typography>
                      <Typography>-</Typography>
                      <Typography color='success.main'>{range}</Typography>
                      <Typography>/</Typography>
                      <Typography color='error.text'>{notRange}</Typography>
                    </Stack>
                  )
                },
              },
              {
                field: "waiting",
                headerName: bt("WAITING"),
                width: 150,
                filterable: false,
                renderCell: (value) => {
                  const total = value?.row?.waiting?.total
                  const range = value?.row?.waiting?.range
                  const notRange = value?.row?.waiting?.notRange
                  return (
                    <Stack height='100%' alignItems='center' direction='row' spacing={0.5}>
                      <Typography>{total}</Typography>
                      <Typography>-</Typography>
                      <Typography color='success.main'>{range}</Typography>
                      <Typography>/</Typography>
                      <Typography color='error.text'>{notRange}</Typography>
                    </Stack>
                  )
                },
              },
              {
                field: "close",
                headerName: bt("CLOSE"),
                width: 150,
                filterable: false,
                renderCell: (value) => {
                  const total = value?.row?.close?.total
                  const range = value?.row?.close?.range
                  const notRange = value?.row?.close?.notRange
                  return (
                    <Stack height='100%' alignItems='center' direction='row' spacing={0.5}>
                      <Typography>{total}</Typography>
                      <Typography>-</Typography>
                      <Typography color='success.main'>{range}</Typography>
                      <Typography>/</Typography>
                      <Typography color='error.text'>{notRange}</Typography>
                    </Stack>
                  )
                },
              },
            ]}
            list={comparisonCallWork?.map((item) => {
              return {
                id: item?.id,
                name: item?.name,
                open: item?.open,
                close: item?.close,
                waiting: item?.waiting,
              };
            })}
          />
        </CustomCard>
      </CheckRole>

    </Stack>
  );
};
export default ServicesCall;
